import { FingeringMode, FingeringPart } from '../types/fingering';
import { PART_LABELS } from '../constants/fingering';

// issue #160: 楽譜モード (総譜/パート譜) と総譜時のパート選択を localStorage に永続化する。
// 既存の設定永続化パターン (pdfColorMode.ts) に合わせる。
export const FINGERING_MODE_KEY = 'omakase-unshi:fingering-mode';
export const FINGERING_PART_KEY = 'omakase-unshi:fingering-part';

const VALID_MODES: ReadonlyArray<string> = ['score', 'part'];
// パートの正は PART_LABELS (Guitar1-4)。 型と表示ラベルの単一ソースを共有する。
const VALID_PARTS: ReadonlyArray<string> = Object.keys(PART_LABELS);

const DEFAULT_MODE: FingeringMode = 'part';
const DEFAULT_PART: FingeringPart = 'Guitar1';

/** 保存済みの列挙値を読む。未設定・不正値・storage 例外 (SSR / iframe / 無効化) は fallback。 */
function readEnumSetting<T extends string>(
  key: string,
  validValues: ReadonlyArray<string>,
  fallback: T,
): T {
  if (typeof window === 'undefined') return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (raw && validValues.includes(raw)) return raw as T;
    return fallback;
  } catch {
    return fallback;
  }
}

function writeSetting(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // SSR / iframe / disabled storage — silently ignore
  }
}

export function getFingeringMode(): FingeringMode {
  return readEnumSetting(FINGERING_MODE_KEY, VALID_MODES, DEFAULT_MODE);
}

export function setFingeringMode(mode: FingeringMode): void {
  writeSetting(FINGERING_MODE_KEY, mode);
}

export function getFingeringPart(): FingeringPart {
  return readEnumSetting(FINGERING_PART_KEY, VALID_PARTS, DEFAULT_PART);
}

export function setFingeringPart(part: FingeringPart): void {
  writeSetting(FINGERING_PART_KEY, part);
}
